import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';
import { CSPUrlsMap } from '../../../../routes/CSPUrlsMap';
import { setFullPolicyNumber } from '../../../../store/slice/petDetailsSlice';

export const NewClaimButton = ({ customCss, fullPolicyNumber }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const goToMakeAClaimPage = () => {
    if (fullPolicyNumber) {
      dispatch(setFullPolicyNumber(fullPolicyNumber));
    }
    navigate(CSPUrlsMap.newClaim.url);
  };

  return (
    <div className={`fullWidthButton ${customCss}`}>
      <button
        type="button"
        className="button primary fullWidthButton"
        onClick={goToMakeAClaimPage}
      >
        <span>
          <Icon icon="claim-new" />
        </span>
        <span className="labelText">Make a new claim</span>
      </button>
    </div>
  );
};

NewClaimButton.propTypes = {
  customCss: PropTypes.string,
  fullPolicyNumber: PropTypes.string
};
